// extracted by mini-css-extract-plugin
export default {"wrap":"X-z","heading":"Y-z","formError":"Z-z"};